export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    console.log(e);
    return true;
  }
};
